import React, { useMemo } from 'react';

import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function TabPanel({ children, value, index, ...rest }) {
  const isHidden = useMemo(() => value !== index, [value, index]);

  return (
    <S.Wrapper
      role="tabpanel"
      hidden={isHidden}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...rest}
    >
      {!isHidden && <Box p={3}>{children}</Box>}
    </S.Wrapper>
  );
}

TabPanel.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};
